<template>
  <div class="bg-gray-900 text-center h-full font-mono about-container h-screen projects-tab">
    <h1 class="title text-3xl text-gray-200 font-bold pt-3">Portfolio</h1>

    <div class="row">
      <div class="w-1/2  m-3 cell rounded-sm cursor-pointer border-4 border-teal-300 hover:bg-teal-300 text-white hover:text-gray-900 text-xl" @click="openAnnkissam()">Annkissam</div>
      <div class="w-1/2  m-3 cell rounded-sm cursor-pointer border-4 border-teal-300 hover:bg-teal-300 text-white hover:text-gray-900 text-xl" @click="openWovnio()">Wovn.io</div>
    </div>
    <div class="row">
      <div class="w-1/2  m-3 cell rounded-sm cursor-pointer border-4 border-teal-300 hover:bg-teal-300 text-white hover:text-gray-900 text-xl" @click="openToptal()">Toptal</div>
      <div class="w-1/2  m-3 cell rounded-sm cursor-pointer border-4 border-teal-300 hover:bg-teal-300 text-white hover:text-gray-900 text-xl" @click="openTheIncreaser()">The Increaser</div>
    </div>
  </div>
</template>
<script>

export default {
  methods: {
    openAnnkissam() {
      this.$parent.openAnnkissam()
    },
    openWovnio() {
      this.$parent.openWovnio()
    },
    openToptal() {
      this.$parent.openToptal()
    },
    openTheIncreaser() {
      this.$parent.openTheIncreaser()
    }
  }
}
</script>
<style>
  .projects-tab {
    min-height: 400px;
  }
  .row {
    height: 30%;
    display: flex;
  }
  .cell {
    padding: 23px 0;
    height: 92%;
    transition: background-color 0.5s, border-color 0.5s, width 0.5s, height 0.5s;
  }
  .cell:hover {
    width: 53%;
    height: 95%;
  }
  @media screen and (max-width: 640px) {
    .row {
      display: grid;
      height: 40%;
    }
    .cell {
      height: 92%;
      width: 92% !important;
      margin: 1% 4% !important;
    }

    .cell:hover {
      height: 93% !important;;
      width: 93% !important;
    }
  }
</style>
